import { useLocation } from 'react-router-dom';
import { EMAIL_VERIFICATION_QUERY_PARAMETER } from '../config/ui-constants';

export const useVerificationCode = () => {
    const location = useLocation();
    const search = new URLSearchParams(location.search);
    const code = search.get(EMAIL_VERIFICATION_QUERY_PARAMETER);
    return code;
};
